(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["caprus-pair-cart"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('caprus-pair-cart')){
customElements.define('caprus-pair-cart',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const button=this.querySelector('button');
button.addEventListener('click',async()=>{
const error=this.querySelector('[role="status"]');error.hidden=true;button.disabled=true;
try{
const drawer=document.querySelector('cart-drawer');
const body={items:[{id:Number(this.querySelector('select').value),quantity:1}],sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:window.location.pathname};
const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
const data=await response.json();if(!response.ok||data.status)throw new Error('cart');
drawer.renderContents(data);
}catch(e){error.hidden=false;button.disabled=false;}
});
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caprus-wool-pair"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caprus-wool-pair')) {
customElements.define('caprus-wool-pair', class extends HTMLElement {
connectedCallback() {
if(this.ready) return;
this.ready=true;
const button=this.querySelector('button');
const selects=this.querySelectorAll('select');
if(selects[1].options.length>1) selects[1].selectedIndex=1;
button.addEventListener('click',async()=>{
const error=this.querySelector('[role="status"]');
error.hidden=true;button.disabled=true;
try{
const cart=document.querySelector('cart-drawer') || document.querySelector('cart-notification');
if(cart && cart.setActiveElement) cart.setActiveElement(button);
const ids=Array.from(selects).map(s=>Number(s.value));
const items=ids[0]===ids[1]?[{id:ids[0],quantity:2}]:ids.map(id=>({id,quantity:1}));
const body={items,sections_url:window.location.pathname};
if(cart && cart.getSectionsToRender) body.sections=cart.getSectionsToRender().map(s=>s.id);
const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
const data=await response.json();
if(!response.ok || data.status) throw new Error('cart');
if(cart && data.sections && cart.renderContents) {
cart.classList.remove('is-empty');
cart.renderContents(data);
} else {window.location.assign(window.Shopify.routes.root+'cart');}
}catch(e){error.hidden=false;}finally{button.disabled=false;}
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
